module.exports = __webpack_public_path__ + "static/NZ-b6ecbd111d7ad7e5d8edfb957210fc46.svg";